import { displayLocale } from "./localization";

export const decimalGB = 1_000_000_000;

export function formatNetworkBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return "–";
  if (bytes >= decimalGB) return `${(bytes / decimalGB).toLocaleString(displayLocale, { maximumFractionDigits: 2 })} GB`;
  if (bytes >= 1_000_000) return `${(bytes / 1_000_000).toLocaleString(displayLocale, { maximumFractionDigits: 1 })} MB`;
  if (bytes >= 1_000) return `${(bytes / 1_000).toLocaleString(displayLocale, { maximumFractionDigits: 1 })} kB`;
  return `${bytes.toLocaleString(displayLocale)} B`;
}
